import { GPS_TIME_MAX_STALLED_SHARE } from '../../analysis/config/telemetryChecks'
import type { GpsStreamCheck } from './gpsStreamTrust'
import { isUsableGpsFix, type GpsFixReading } from '../gpsFix'

function stalledSteps(fixes: readonly GpsFixReading[]): number {
  let stalled = 0
  for (let i = 1; i < fixes.length; i++) {
    if (fixes[i].timeMs <= fixes[i - 1].timeMs) stalled++
  }
  return stalled
}

export function stalledTimeShare(fixes: readonly GpsFixReading[]): number {
  return fixes.length < 2 ? 0 : stalledSteps(fixes) / (fixes.length - 1)
}

export const timeAdvances: GpsStreamCheck = {
  id: 'timeAdvances',
  run(fixes, trust) {
    const usable = fixes.filter(isUsableGpsFix)
    if (stalledTimeShare(usable) <= GPS_TIME_MAX_STALLED_SHARE)
      return { trust, finding: null }
    return {
      trust: { ...trust, timeTrusted: false },
      finding: {
        check: 'timeAdvances',
        level: 'stream',
        aspect: 'gpsTime',
        verdict: 'unreliable',
        affected: stalledSteps(usable),
        of: usable.length - 1,
        reason: 'The recording’s clock stalls, so lap times are unreliable',
      },
    }
  },
}
